import { Layout } from 'antd'
import { observer } from 'mobx-react-lite'
import { useRouteMatch } from 'react-router-dom'
import UserRouters from '../../routes/UserRouters'
import Sidebar from '../sidebar/Sidebar'
import Topbar from '../topbar'
import { userMeta } from '../../routes/metaData'

const { Content } = Layout

const LayoutUser = observer((props: any) => {
   const match = useRouteMatch()
   // const history = useHistory()
   return (
      <Layout className="gx-app-layout layout-admin">
         {/* <StickyChatButton /> */}
         <Sidebar {...props} sideBarContent={userMeta} />
         <Layout>
            <Topbar {...props} />
            <Content>
               <UserRouters match={match} />
            </Content>
         </Layout>
      </Layout>
   )
})

export default LayoutUser
